var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('RouterView'),_c('div',{staticClass:"version d-print-none"},[_vm._v("v"+_vm._s(_vm.version))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }